import React, { useLayoutEffect, useRef } from 'react';

export const Dialog = ({ title, wide, onClose, children, lang }) => {
  const ref = useRef(null);
  const lastFocus = useRef(document.activeElement);
  useLayoutEffect(() => {
    const dialog = ref.current;
    const returnTarget = lastFocus.current;
    const overflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    if (!dialog.open) dialog.showModal();
    return () => {
      dialog.close();
      document.body.style.overflow = overflow;
      if (returnTarget?.isConnected) returnTarget.focus({ preventScroll: true });
    };
  }, []);
  const backdrop = e => {
    if (e.target !== ref.current) return;
    const r = ref.current.getBoundingClientRect();
    if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) onClose();
  };
  const keyboard = e => {
    if (e.key !== 'Tab') return;
    const focusable = [...ref.current.querySelectorAll('button,a[href],input,select,textarea,[tabindex="0"]')].filter(el => !el.disabled && el.getClientRects().length);
    const first = focusable[0], last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last?.focus(); }
    if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first?.focus(); }
  };
  return <dialog ref={ref} className={`dialog${wide ? ' wide' : ''}`} aria-labelledby="dialog-title" data-testid="site-dialog" onClick={backdrop} onKeyDown={keyboard} onCancel={e => { e.preventDefault(); onClose(); }}>
    <div className="dialog-head" data-testid="dialog-heading"><h2 id="dialog-title" data-testid="dialog-title">{title}</h2><button className="close" type="button" aria-label={lang === 'mr' ? 'बंद करा' : 'Close dialog'} onClick={onClose} data-testid="dialog-close">×</button></div>
    <div className="dialog-body" data-testid="dialog-body">{children}</div>
  </dialog>;
};